const validId = (id) => /^[a-f\d]{24}$/i.test(String(id || ""))
export const creationErrorMessage = (message) =>
  ({
    INVALID_EVENT_COORDINATOR:
      "The coordinator is no longer available. Choose another coordinator.",
    INVALID_EVENT_CLASSIFICATION:
      "An event option has changed. Reload the available settings.",
    INVALID_EVENT_ORGANIZER:
      "This organizer is not available for the selected club.",
    EVENT_CLUB_UNAVAILABLE:
      "The club is no longer active. Choose another club.",
    INVALID_EVENT_COUNTRY: "Select a supported event country.",
    // A Tenis10 event is tennis (PRD 16 LR11); its competitions are added after creation.
    INVALID_EVENT_PROGRAMME: "A Tenis10 event is a tennis event. Select Tenis10 again in Sport.",
    INVALID_EVENT_COMPETITIONS: "Add the competitions after creating the event.",
    INVALID_EVENT_OFFICIAL_BALL:
      "The official ball is no longer in the settings. Choose it again, or Balls TBD.",
    // The card's supplier for balls without a product, or a product chosen there that no longer fits.
    INVALID_EVENT_LOGISTICS:
      "Review the Logistics card: MPG supplies only balls a catalogue product covers, "
      + "and a product chosen there must still be active and fit the event.",
    ERROR_PERMISSIONS: "Your session does not allow event creation.",
    // The gateway's refusals, answered before anything is sent: the form keeps the details.
    SESSION_EXPIRED:
      "Your session expired, so the event was not created. Sign in again in a new tab, then select Create event here; your details are kept.",
    FORBIDDEN: "Only a super admin can create events.",
  }[message] ||
  "The event could not be created. Check the fields and try again.")

export function runEventCreation({
  submit,
  read,
  socket,
  operationId,
  timeoutMs = 60000,
  pollMs = 2000,
}) {
  let ended = false,
    resolve,
    pollTimer
  const promise = new Promise((done) => {
    resolve = done
  })
  const finish = (result) => {
    if (ended) return
    ended = true
    clearTimeout(deadline)
    clearTimeout(pollTimer)
    socket?.off("events-response", onResponse)
    resolve(result)
  }
  const onResponse = (response) => {
    if (
      response?.operationId !== operationId ||
      response?.operation !== "event-created"
    )
      return
    if (response.success === true && validId(response.data?.id))
      finish({
        status: "saved",
        id: response.data.id,
        warning: response.warning,
      })
    else if (response.success === false)
      finish(
        response.retryable
          ? { status: "unknown" }
          : {
              status: "error",
              message: creationErrorMessage(response.message),
            }
      )
  }
  const poll = async () => {
    if (ended) return
    try {
      const response = await read(operationId)
      if (response?.data?.status === "saved" && validId(response.data.id)) {
        finish({
          status: "saved",
          id: response.data.id,
          ...(response.data.warning ? { warning: response.data.warning } : {}),
        })
      }
    } catch (_error) {
      /* A failed status read does not prove the creation failed. */
    }
    if (!ended) pollTimer = setTimeout(poll, pollMs)
  }
  const deadline = setTimeout(() => finish({ status: "unknown" }), timeoutMs)
  socket?.on("events-response", onResponse)
  pollTimer = setTimeout(poll, submit ? pollMs : 0)
  if (submit)
    Promise.resolve()
      .then(() => {
        if (!ended) return submit(operationId)
      })
      .then((response) => {
        if (response?.success === false)
          finish({
            status: "error",
            message: creationErrorMessage(response.message),
          })
      })
      .catch((error) => {
        if (error.response?.status >= 400 && error.response.status < 500) {
          finish({
            status: "error",
            message:
              error.response.data?.details?.[0]?.message ||
              creationErrorMessage(error.response.data?.message),
          })
        }
      })
  return { promise, cancel: () => finish({ status: "cancelled" }) }
}
